import { datadogLogs } from '@datadog/browser-logs';
import { addReactError } from '@datadog/browser-rum-react';
import React from 'react';
import FallbackUI from './FallbackUI';

// https://docs.datadoghq.com/integrations/rum-react/#react-19-createroot-error-handling

class ErrorBoundary extends React.Component<any, any> {
  constructor(props) {
    super(props);
    // state to track whether is an error or not
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  // we will not get access to this and errorInfo in functional component
  componentDidCatch(error, errorInfo) {
    // we can use our own error logging service also here
    addReactError(error, errorInfo);

    const context = {
      capturedBy: 'ReactErrorBoundary',
      error_boundary: true,
      oops_page_shown: true,
      error_message: error?.message || 'Unknown error',
      component_stack: errorInfo?.componentStack || '',
      url: window.location.href,
    };

    // Wrap Datadog call in try/catch: this is the root error boundary, so any throw
    // here unmounts the whole tree (no parent boundary above) and shows a blank page
    // instead of FallbackUI. Matches the codebase convention in src/utils/datadog-error.ts.
    try {
      datadogLogs.logger.error('React Error Boundary: Oops page shown to customer', context, error);
    } catch (e) {
      console.error('Failed to log oops page to Datadog:', e);
    }
  }

  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // render custom fallback UI
      return <FallbackUI />;
    }

    // else Return children components in case of no error
    return this.props.children;
  }
}

export default ErrorBoundary;
